import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/home/index.vue";

import Meta from "vue-meta";
import auth from "@/router/auth";

Vue.use(VueRouter);

Vue.use(Meta, {
  keyName: "metaInfo", // the component option name that vue-meta looks for meta info on.
  attribute: "data-vue-meta", // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: "data-vue-meta-server-rendered", // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: "vmid", // the property name that vue-meta uses to determine whether to overwrite or append a tag
});

const routes = [
  {
    path: "/dashboard",
    name: "home-index",
    component: Home,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/login",
    name: "account-login",
    component: () => import("@/views/account/Login.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/for-bidden",
    name: "for-bidden",
    component: () => import("@/views/error_page/403.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/register",
    name: "account-register",
    component: () => import("@/views/account/Register.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  // Profile
  {
    path: "/profile",
    name: "account-profile",
    component: () => import("@/views/account/Profile.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/warehouse-import",
    name: "warehouse-import",
    component: () => import("@/views/warehouse_import/List.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/pack-unconfirmed",
    name: "pack-unconfirmed",
    component: () => import("@/views/pack-unconfirmed/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  // vai trò tài khoản
  //
  {
    path: "/setting",
    name: "setting",
    redirect: "/setting/company",
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/setting/warehouse",
    name: "setting-warehouse",
    component: () => import("@/views/setting/WarehouseList.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/setting/company",
    name: "setting-company",
    component: () => import("@/views/setting/Company.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/setting/company/:id",
    name: "setting-company-detail",
    component: () => import("@/views/setting/CompanyDetail.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/export-warehouse/car",
    name: "export-warehouse-car",
    component: () => import("@/views/setting/Car.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/setting/location",
    name: "setting-location",
    component: () => import("@/views/setting/Location.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/setting/bag-status",
    name: "setting-bag-status",
    component: () => import("@/views/setting/BagStatus.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  // ds nhân viên
  {
    path: "/setting/users",
    name: "users",
    component: () => import("@/views/user/List.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/account/role-management",
    name: "admin.role.index",
    component: () => import("@/views/administrator/List.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/account/role-create",
    name: "role-create",
    component: () => import("@/views/administrator/CreateRole.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/account/role-update/:id",
    name: "role-update",
    component: () => import("@/views/administrator/UpdateRole.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/account/roles",
    name: "account-roles",
    component: () => import("@/views/administrator/List.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/account/list-user",
    name: "account-lists-user",
    component: () => import("@/views/account/AccountList.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/account/customer-list",
    name: "customers-list",
    component: () => import("@/views/customer/List.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/storage-warehouse",
    name: "storage-warehouse",
    component: () => import("@/views/storage-warehouse/List.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/storage-warehouse/by-bill",
    name: "storage-warehouse-by-bill",
    component: () => import("@/views/storage-warehouse/ListByBill.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/storage-warehouse/by-customer",
    name: "storage-warehouse-by-customer",
    component: () => import("@/views/storage-warehouse/ListByCustomer.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/agency/create",
    name: "agency-create",
    component: () => import("@/views/agency/Create.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/agency",
    name: "agency",
    component: () => import("@/views/agency/List.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/storage-waiting-export",
    name: "storage-waiting-export",
    component: () => import("@/views/agency/StorageWh.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  /*{
    path: "/storage-warehouse/create-export",
    name: "create-warehouse-export",
    component: () => import("@/views/warehouse_export/Create.vue"),
    beforeEnter: auth.requireAuthV2,
  },*/
  {
    path: "/warehouse-export/print/:id",
    name: "PrintExport",
    component: () => import('@/views/warehouse_export/PrintExport.vue'),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/export-warehouse",
    name: "export-warehouse",
    component: () => import("@/views/export-warehouse/List.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/agency/edit/:id",
    name: "agency-edit",
    component: () => import("@/views/agency/Edit.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  // tạo phiếu xuất kho
  {
    path: "/storage-warehouse/warehouse-release-note",
    name: "warehouse-release-note",
    component: () => import("@/views/storage-warehouse/WarehouseReleaseNote.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  // In Barcode
  {
    path: "/print-barcode/:code",
    name: "print-barcode",
    component: () => import("@/views/print-group/InBarcode.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  // In Tem
  {
    path: "/print-tem/:import_id/:export_id/:bag_code",
    name: "print-tem",
    component: () => import("@/views/print-group/InTem.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  // In Barcode Multi
  {
    path: "/print-barcode-multi/:arr_barcode",
    name: "print-barcode-multi",
    component: () => import("@/views/print-group/InBarcodeMulti.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  // tạo phiếu xuất kho
  {
    path: "/storage-warehouse/return-goods-list",
    name: "return-goods-list",
    component: () => import("@/views/return_goods/ReturnGoodsList.vue"),
    beforeEnter: auth.requireAuthV2,
  },

  {
    path: "/print-tem-multi/:import_id/:export_id/:arr_barcode/:rollback?",
    name: "print-tem-multi",
    component: () => import("@/views/print-group/InTemMulti.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/return-orders",
    name: "return-orders",
    component: () => import("@/views/return_order/List.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/storage-warehouse/expected-vehicle-arrangement",
    name: "expected-vehicle-arrangement",
    component: () => import("@/views/arrangement/Index"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/print-tem-multi-storage/:arr_id",
    name: "print-tem-multi-storage",
    component: () => import("@/views/storage-warehouse/InTemMultiStorage.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/return-orders/history",
    name: "return-history-orders",
    component: () => import("@/views/return_order/History.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/export-warehouse/list-goods",
    name: "export-warehouse-list-goods",
    component: () => import("@/views/export-warehouse/ListGood.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/storage-warehouse/list-returned-goods",
    name: "list-returned-goods",
    component: () => import("@/views/storage-warehouse/ListReturnedGoods"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/storage-warehouse/list-fee-ship",
    name: "list-fee-ship",
    component: () => import("@/views/storage-warehouse/ListFeeShip"),
    beforeEnter: auth.requireAuthV2,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
